import i18n from "../utils/i18n"
import { ROUTE_PATHS } from "./url-config";

export const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])[A-Za-z0-9_@./#&+-]{8,}$/;

export const GOOGLEMAP_API_KEY = process.env.REACT_APP_GOOGLE_MAP_KEY || "";

export const DateFormat = {
    view: "MMM D, YYYY",
    dateTimeView: "MMMM Do YYYY, h:mm:ss a",
    monthView: "MMM, YYYY",
    server: "YYYY-MM-DD",
    review: "h:mm a MMMM D",
}

export const DateTimeNow = "now";

export const LeftSiderBarWith = 312 // px

export const BreadcrumbsLength = 3 //

enum CharactersPositionType {
    front = "front",
    behind = "behind"
}

export const AmountFormat = {
    thousandSeperator: ",",
    decimalSeperator: ".",
    allowedDecimals: 2,
    currencyCharacters: "$",
    charactersPosition: CharactersPositionType.front
}

export const FormChangeDebounceTime = 2000 // milisecond
export const AutoRedirectAfterSubmitSuccessfully = 3000 // 5s
export const AutoRefreshCalculationReportProcess = 15000;

export const RISK_LEVELS = [
    {
        name: i18n.t("Global.lbNone"),
        value: "NONE"
    }, {
        name: i18n.t("Global.lbLow"),
        value: "LOW"
    }, {
        name: i18n.t("Global.lbMedium"),
        value: "MEDIUM"
    }, {
        name: i18n.t("Global.lbHigh"),
        value: "HIGH"
    }
]

export const STATUS_DOCUMENTATIONS = [
    {
        name: i18n.t("ControlFailure.lbOpen"),
        value: "OPEN"
    }, {
        name: i18n.t("ControlFailure.lbMonitor"),
        value: "MONITOR"
    }, {
        name: i18n.t("ControlFailure.lbClosed"),
        value: "CLOSE"
    }
]

export const RECOVERY_STATUS = [
    {
        name: i18n.t("ControlFailure.lbNoRecovery"),
        value: "NO"
    }, {
        name: i18n.t("ControlFailure.lbRecoveryEligible"),
        value: "ELIGIBLE"
    }, {
        name: i18n.t("ControlFailure.lbRecoveryComplete"),
        value: "COMPLETE"
    }
]

export const RISK_TYPES = [
    {
        name: i18n.t("Scenario.lbPureOperationalRisk"),
        value: "PURE_OPERATIONAL"
    }, {
        name: i18n.t("Scenario.lbOverlapWithCreditRisk"),
        value: "OVERLAP_CREDIT"
    }, {
        name: i18n.t("Scenario.lbOverlapWithMarketRisk"),
        value: "OVERLAP_MARKET"
    }, {
        name: i18n.t("Scenario.lbOverlapWithBot"),
        value: "OVERLAP_BOTH"
    }
]

export const VALIDATION_MESSAGE_CONFIG = {
    required: i18n.t("Global.requireValidation"),
    types: {
        email: i18n.t("Global.emailValidation"),
    }
};

export enum MitigationSouresType {
    External = "EXTERNAL",
    Internal = "INTERNAL"
}

export enum UserActionEnum {
    View = "view",
    Review = "review",
    Submited = "submited"
}

export enum MitigationType {
    Start = "start"
}

export enum ReportStatesEnum {
    New = "NEW",
    Draft = "DRAFT",
    Submitting = "SUBMITTING",
    Submitted = "SUBMITTED",
    Approved = "APPROVED",
    Rejected = "REJECTED"
}

export const MONTHS = [
    {
        value: 1,
        name: i18n.t("Global.month01"),
    }, {
        value: 2,
        name: i18n.t("Global.month02"),
    }, {
        value: 3,
        name: i18n.t("Global.month03"),
    }, {
        value: 4,
        name: i18n.t("Global.month04"),
    }, {
        value: 5,
        name: i18n.t("Global.month05"),
    }, {
        value: 6,
        name: i18n.t("Global.month06"),
    }, {
        value: 7,
        name: i18n.t("Global.month07"),
    }, {
        value: 8,
        name: i18n.t("Global.month08"),
    }, {
        value: 9,
        name: i18n.t("Global.month09"),
    }, {
        value: 10,
        name: i18n.t("Global.month10"),
    }, {
        value: 11,
        name: i18n.t("Global.month11"),
    }, {
        value: 12,
        name: i18n.t("Global.month12"),
    }
]

export const DIRECTIONS = [{
    value: false,
    name: i18n.t("ScenarioFrontier.lbNegative")
}, {
    value: true,
    name: i18n.t("ScenarioFrontier.lbPositive")
}]

export enum SourceModuleEnum {
    LossEvent = "loss_event",
    LossScenario = "loss_scenario",
    RAMP = "rapm_report",
    ECAP = "ecap_approval"
}

export enum ReportStatusEnum {
    Pending = "pending",
    Approved = "approved",
    Referred = "referred"
}

export enum FilterModuleEnum {
    None = "",
    Ecap = "ecap_approval",
    ERM = "ecap_erm",
    RAPM = "ecap_rapm"
}

export enum ReportActivitiesEnum {
    Approve = "approve_report",
    Refer = "refer_report",
    Comment = "comment"
}

export enum ReportAnalysisProcessEnum {
    Processed = "processed",
    Processing = "processing",
    error = "error"
}

export enum CreateRiskReportStep {
    SelectPeriod = 0,
    UploadFile,
    ViewResult,
    SubmitForApproval
}

export enum RAPMReportFormat {
    Json = "header",
    File = "csv"
}

export const SERVER_REDIRECT = [
    {
        key: "create_scenario_assessment",
        value: ROUTE_PATHS.AddScenario
    }
]

export enum ReportTypeEnum {
    CreditRisk = "cr",
    MarketRisk = "mr",
    OperationalRisk = "or",
    BusinessRisk = "br",
    ConcentrationRisk = "conr",
    InterestRateRisk = "irr",
    Ramp = "rapm",
    common = "common",

    // Scenario frontier
    CreditandConcentrationStressTesting = "SFSB"
}

export enum EcapReportGroupEnum {
    Pillar1 = 1,
    Pillar2
}

export const REPORTQUERYPARAMS = {
    year: "year",
    quarter: "quarter"
}

export enum ScenarioFrontierFileType {
    SFSB_RESULT_1 = "SFSB_RESULT_1",
    SFSB_RESULT_2 = "SFSB_RESULT_2",
    SFSB_RESULT_3 = "SFSB_RESULT_3",
    SFSB_RESULT_4 = "SFSB_RESULT_4",
    SFSB_RESULT_5 = "SFSB_RESULT_5",
    SFSB_RESULT_6 = "SFSB_RESULT_6"
}

export enum ChartValueType {
    Number,
    Currency,
    Percent
}